module.exports = __webpack_public_path__ + "static/media/virisol_1.554dc16d.png";